__turbopack_context__.v({
  "statBoxWrapper": "_2NsOhW_statBoxWrapper",
  "themeParkLogoFigure": "_2NsOhW_themeParkLogoFigure",
  "themeParkLogoImage": "_2NsOhW_themeParkLogoImage",
});
